function toRadians(degrees) {
    return degrees * Math.PI / 180;
};

function toDegrees(radians) {
    return radians * 180 / Math.PI;
};

/**
 * Calculates bearing from start to destination.
 * @param {Array} start Point of Origin, accepts a coordinate array like [X, Y, Z]
 * @param {Array} dest Destination, accepts a coordinate array like [X, Y, Z]
 * @returns Bearing from start, with North as 0
 */
export function bearing(start, dest) {
    let brng = Math.atan2(dest[2]-start[2], dest[0]-start[0]) * 180 / Math.PI;
    return (brng + 90) % 360;
}

/**
 * Calculates bearing from start to destination and returns a user-readable string of the cardinal direction.
 * @param {Array} coords Destination, accepts a coordinate array like [X, Y, Z]
 * @param {Array|null} center Point of Origin, accepts a coordinate array like [X, Y, Z] - Default Value: [22, -49, -8] (world spawn)
 * @returns {String} Returns string of either 'North', 'North-East', 'East', 'South-East', 'South', 'South-West', 'West', 'North-West', 'Central'.
 */
export function cardinal(coords, center = [22, -49, -8]) {
    let angle = bearing(center, coords);

    let directions = ['North', 'North-East', 'East', 'South-East', 'South', 'South-West', 'West', 'North-West', 'Central'];
    let index = Math.round(((angle %= 360) < 0 ? angle + 360 : angle) / 45) % 8;
    
    if (coords[0] == center[0] && coords[2] == center[2]) index = 8;

    return directions[index];
};

function vectorDistance(dx, dy) {
    return Math.sqrt(dx * dx + dy * dy);
};

/**
 * Calculates the distance between two coordinates.
 * @param {Array} start Point of Origin, accepts a coordinate array like [X, Y, Z]
 * @param {Array} dest Destination, accepts a coordinate array like [X, Y, Z]
 * @returns {Number} Distance between start and dest, in blocks
 */
export function calculateDistance(start, dest) {
    var dx = parseInt(start[0]) - parseInt(dest[0]),
        dy = parseInt(start[2]) - parseInt(dest[2]);

    return vectorDistance(dx, dy);
};

/**
 * Orders an array of places by distance
 * @param {Array} origin Point of Origin, accepts a coordinate array like [X, Y, Z]
 * @param {Array} placeList List of places to check from
 * @returns {Array} placeList, sorted in order of closest to furthest
 */
export function closestLocation(origin, placeList) {
    let output = [];
    for (var place of placeList) {
        if (place.PlaceLocation.MainCoords) {
            let distance = calculateDistance(origin, place.PlaceLocation.MainCoords);
            place.distance = distance;
            output.push(place);
        };
    };        
    output.sort((a, b) => (a.distance > b.distance) ? 1 : -1);
    return output;
}

/**
 * 
 * @returns 
 */
export async function getDynmap() {
    let data = await fetch('/dynmap').then(res => {return res.json()});
    return data;
}